import api from "@services/api";

export const getAllExtractionRights = async (
  params: Record<string, any> = {}
) => {
  const { data } = await api.get("/extractionRights", { params });

  return data.extractionRights;
};
